import { ComponentIds } from '@inter-ikea-core/core';
import { UnavailableProductComponent } from '../..';
import { PlannerEcsMultiSystem } from './System';
/**
 * This system listens for added and removed entities with unavailable product component
 * and dispatches an 'unavailableProductsUpdated' event
 */
export class UnavailableProductsEventSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'UnavailableProductsEventSystem', [
            ComponentIds.IN_SCENE_COMPONENT_ID,
            UnavailableProductComponent.id
        ]);
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID &&
            entity.hasComponent(UnavailableProductComponent.id)) {
            this.onUnavailableProductUpdated();
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === UnavailableProductComponent.id ||
            (oldComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID &&
                entity.hasComponent(UnavailableProductComponent.id))) {
            this.onUnavailableProductUpdated();
        }
    }
    onUnavailableProductUpdated() {
        this.coreApi.emit.onUnavailableProductsUpdated();
    }
}
//# sourceMappingURL=UnavailableProductsEventSystem.js.map